export default "__VITE_ASSET__DmaDyklj__"